import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Redirect, Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import SurveyFirstPageSettings from 'pages/Admin/Surveys/SurveySettings'
import SurveyConfigurationSettings from 'pages/SurveyConfigurationSettings'
import SurveySettingsHeader from 'organisms/SurveySettingsHeader'
import { Steps } from 'organisms/Steps'
import { getSurveyFromId } from 'reducers'
import constants from 'config/constants'
import { SurveySettingProvider, SurveySettingConsumer } from './context'
import UnsavedChangesGuard from 'shared/components/UnsavedChangesGuard'
import useAxios from 'hooks/useAxios'
import { toast } from 'libs/toast'
import SurveyPublishSettingV2 from 'pages/SurveyPublishSettingV2'
import { Loader } from 'shared/components/Loader'
import useUser from 'hooks/useUser'
import { AdminContainer } from '../Admin'
import useWorkspace from 'hooks/useWorkspace'

class InnerSideEffectHandler extends React.Component {
  static propTypes = {
    context: PropTypes.object,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      const surveySettingContext = this.props.context
      surveySettingContext.setContext({ currentSaveFunction: null, isSurveyBuilderDirty: false })
    }
  }

  render() {
    // Guards the whole survey editor (Build / Configure / Publish tabs, which all
    // feed isSurveyBuilderDirty) against both in-app navigation AND hard refresh /
    // tab-close — guardRefresh defaults to true. PO decision (PET-2084): be
    // consistent with the billing page and feedback-widget guards, which warn on
    // refresh too.
    return <UnsavedChangesGuard when={this.props.context.isSurveyBuilderDirty} />
  }
}

const SideEffectHandler = withRouter(InnerSideEffectHandler)

const Component = ({ match, survey: surveyFromRedux }) => {
  const { surveyId } = match.params
  const {
    loading,
    data,
    error: surveyNotFound,
  } = useAxios({
    url: `account/survey/${surveyId}/`,
  })
  const user = useUser()
  const workspaceToken = useWorkspace()

  if (!user || loading) {
    return <Loader withContainer />
  }

  if (!data && surveyNotFound) {
    const isSurveyMissing = surveyNotFound.response?.status === 404
    toast.error(
      isSurveyMissing
        ? constants.surveyNotFoundErrorMessage
        : constants.permissionDeniedErrorMessage
    )
    return <Redirect to={`/${workspaceToken}/settings/surveys/`} />
  }

  const survey = surveyFromRedux || data
  if (!survey) {
    return <Loader withContainer />
  }

  const currentPath = match.path
  return (
    <SurveySettingProvider>
      <SurveySettingConsumer>
        {(context) => <SideEffectHandler context={context} />}
      </SurveySettingConsumer>
      <SurveySettingsHeader survey={survey} surveyToken={survey.token} />
      <AdminContainer>
        <div className="ui segment admin-section">
          <Steps />
          <Switch>
            <Redirect exact from={`${currentPath}`} to={`${currentPath}settings/`} />
            <Route path={`${currentPath}settings/`} component={SurveyFirstPageSettings} />
            <Route path={`${currentPath}configure/`} component={SurveyConfigurationSettings} />
            <Route path={`${currentPath}publish/`} component={SurveyPublishSettingV2} />
            <Route render={() => <Redirect to="/404/" />} />
          </Switch>
        </div>
      </AdminContainer>
    </SurveySettingProvider>
  )
}

Component.propTypes = {
  match: PropTypes.object.isRequired,
  survey: PropTypes.object,
}

const mapState = (state, ownProps) => ({
  survey: getSurveyFromId(state, ownProps.match.params.surveyId),
})

export const SurveySettings = connect(mapState)(Component)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/SurveySettings/index.js